<template>
  <div>
    <hl-Input
      type="text"
      v-model="internalValue"
      :placeholder="companyPlaceHolder"
      :label="label"
      @input="waitAndFetch"
      autocomplete="companyName_a56e3"
      data-cy="company-search-field"
    />

    <hl-ErrorMessage v-if="internalValue.length < 3 && internalValue.length > 0"
      data-cy="company-search-string-too-short-message"
    >
      {{ capitalizeFirst(translate('search string is too short')) }}
    </hl-ErrorMessage>

    <hl-Loader v-if="searchCompany.loading && internalValue.length > 2" class="p-4" data-cy="company-search-loader"/>

    <ul
      v-if="searchCompany.display && !searchCompany.error && !searchCompany.loading"
      class="text-left list-unstyled results-container"
      data-cy="company-search-results"
    >
      <li v-for="company in searchCompany.result" :key="company.organisasjonsnummer" @click="setCompany(company)">
        {{ company.navn }}
        {{ company.organisasjonsnummer }}
      </li>
    </ul>

    <p v-if="searchCompany.error" class="text-left pt-3 text-danger" data-cy="company-search-error-message">
      {{ searchCompany.error_message }}
    </p>
  </div>
</template>

<script>
import Input from '@modules/husleie-framework/src/components/forms/inputs/input/Input.vue';
import Loader from '@modules/husleie-framework/src/components/loaders/Loader.vue';
import ErrorMessage from '@modules/husleie-framework/src/components/text/ErrorMessage.vue';
import i18nCommon from '@modules/i18n/mixins/Common';
import axios from 'axios';

export default {
  mixins: [i18nCommon],
  components: {
    'hl-ErrorMessage': ErrorMessage,
    'hl-Loader': Loader,
    'hl-Input': Input,
  },
  props: {
    companyName: String,
    value: String,
  },

  data() {
    return {
      internalValue: '',
      searchCompany: {
        loading: false,
        result: [],
        error: false,
        error_message: '',
        display: false,
        selectedCompany: {},
      },
    };
  },

  mounted() {
    this.internalValue = this.companyName || '';
  },

  computed: {
    companyPlaceHolder() {
      return this.capitalizeFirst(this.translate('demo company'));
    },
    label() {
      const topic = this.translate('company name');
      return this.translate('Search by {topic}', { topic });
    },
  },

  methods: {
    waitAndFetch() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      this.searchTimer = setTimeout(this.fetchData, 300);
    },

    fetchData() {
      this.searchCompany.result = [];
      this.searchCompany.error = false;
      this.searchCompany.error_message = '';
      if (this.internalValue.length > 0) {
        this.searchCompany.loading = true;
        this.searchCompany.display = true;
      } else {
        this.searchCompany.loading = false;
        this.searchCompany.display = false;
      }

      if (this.internalValue.length > 2) {
        axios
          .get('/api/enhetsregisteret/suggestions?query=' + encodeURIComponent(this.internalValue))
          .then(r => {
            this.searchCompany.display = true;
            this.searchCompany.loading = false;
            if (r.status === 200) {
              if (r.data && r.data.length) {
                this.searchCompany.result = [...r.data];
              } else {
                const topic = this.translate('company');
                this.searchCompany.error = true;
                this.searchCompany.error_message = this.capitalizeFirst(
                  this.translate(' {topic} not found', { topic })
                );
              }
            } else {
              this.searchCompany.error = true;
              this.searchCompany.error_message = r.data.message;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
    },

    setCompany(c) {
      this.$emit('companySet', c);
      this.internalValue = c.navn;
      this.searchCompany.display = false;
    },
  },
};
</script>

<style scoped lang="scss">
.results-container {
  background: white;
  max-height: 300px;
  overflow: scroll;
  border-bottom-left-radius: $border-radius;
  border-bottom-right-radius: $border-radius;
  border: 1px solid $gray-400;
  margin-bottom: 0;

  li {
    padding: 1rem;
    border-bottom: 1px solid $gray-200;
    color: $gray-600;
    cursor: pointer;
  }

  li:last-child {
    border-bottom: none;
  }

  li:hover {
    background: $gray-100;
  }
}
</style>
